import { commonErrorApiCodeEdu } from "./errors-api-code-edu";
import { commonErrorApiCodeResourcesEdu } from "./errors-api-code-resources-edu";

// Domain error-code dictionary, composed by the owning app transport.
// Assembled only from generated own namespaces, never from the monolithic catalog.
export const errorCodeDomain = {
  apiCodes: {
    ...commonErrorApiCodeEdu,
  },
  apiCodeResources: {
    ...commonErrorApiCodeResourcesEdu,
  },
  apiCodeReasons: {
  },
} as const;
